;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.order', [
      'kilo.routes.order.show',
      'kilo.routes.order.list'
    ])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
/*    var parentState = {
      name: 'order',
      url: '/order',
      resolve: {},
      abstract: true
    }

    $stateProvider.state(parentState)*/
  }
})(window.angular)
